<template>
  <div class="site-footer bg-theme-sec">
    <Container>

      <div class="links">

        <a href="https://t.me/JGNDeFi" target="_blank">
          <!-- <i class="fab fa-telegram"></i> -->
          <img src="~@/assets/static/img/logo_telegram.png" alt="">
        </a>

        <a href="https://twitter.com/JGNDeFi" target="_blank">
          <!-- <i class="fab fa-twitter"></i> -->
          <img src="~@/assets/static/img/logo_twitter.png" alt="">
        </a>

        <a href="https://medium.com/juggernaut-defi" target="_blank">
          <!-- <i class="fab fa-medium"></i> -->
          <img src="~@/assets/static/img/logo_medium.png" alt="">
        </a>

        <a href="https://github.com/JGNDeFi " target="_blank">
          <!-- <i class="fab fa-reddit"></i> -->
          <img src="~@/assets/static/img/logo_github.png" alt="">
        </a>

        <!-- <a @click="status_open_wechat = true" target="_blank">
          <i class="fab fa-reddit"></i>
          <img src="~@/assets/static/img/logo_wechat.png" alt="">
        </a> -->

        <!-- <a href="/" target="_blank">
          <i class="fab fa-reddit"></i>
          <img src="~@/assets/static/img/logo_queyu.png" alt="">
        </a> -->
        
      </div>
      <div class="text-links c-theme-text tac mt-2 small">
        <!-- <a 
          href="https://lavaswap.medium.com/flame-on-lava-swap-is-imminent-1960ef131702" 
          target="_blank"
          class="mx-1"
          style=""
          >
          <span>
            {{lg('',{
              en: 'About',
              zh: '关于',
            })}}
          </span>
        </a> -->

        <a 
          href="/static/file/Smart_contract_security_audit_report.pdf" 
          target="_blank"
          class="mx-1"
          style=""
          >
          <span>
            {{lg('',{
              en: 'Audit Report',
              zh: '审计报告',
            })}}
          </span>
        </a>

        <a 
          href="/static/file/Smart_contract_security_audit_report2.pdf" 
          target="_blank"
          class="mx-1"
          style=""
          >
          <span>
            {{lg('',{
              en: 'Audit Report 2',
              zh: '审计报告2',
            })}}
          </span>
        </a>

        <a 
          href="/static/file/Smart_contract_security_audit_report3.pdf" 
          target="_blank"
          class="mx-1"
          style=""
          >
          <span>
            {{lg('',{
              en: 'Audit Report 3',
              zh: '审计报告3',
            })}}
          </span>
        </a>
        
         <a 
          href="/static/file/Smart_contract_security_audit_report4.pdf" 
          target="_blank"
          class="mx-1"
          style=""
          >
          <span>
            {{lg('',{
              en: 'Audit Report 4',
              zh: '审计报告4',
            })}}
          </span>
        </a>

      </div>

      <!-- <UiModal :open="status_open_wechat" @close="status_open_wechat = false" class="modal-shell-600">
        <div class="p-4">
          <img 
            src="/static/wechat_lava.jpg"
            style="max-width: 100%;min-height: 290px;"
          >
        </div>
      </UiModal> -->

    </Container>
  </div>
</template>

<script>

export default {
  name: 'siteFooter',
  components: {},
  props: [],
  data() {
    return {
      status_open_wechat: false,
    }
  },
  computed: {},
  watch: {},
  methods: {
    
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';
  
  .site-footer{

    position: absolute !important;
    bottom: 0px !important;

    width: 100%;
    padding-top: 20px !important;
    padding-bottom: 25px !important;

    .links{
      text-align: center;
      font-size: 28px;
      a{
        display: inline-block;
        width: 36px;
        height: 36px;
        line-height: 32px;
        vertical-align: middle;
        background-color: $c;

        border-radius: 30px;
        margin: 0 15px;

        text-align: center;

        img{
          width: 20px;
        }
      }
    }

    .text-links{
      font-size: 16px;
    }


  }
</style>